import React, { useState } from 'react'

import jsonData from '../../data/graduatedStudents.json'

const backet = 'https://bu-page-assets.s3.ap-northeast-1.amazonaws.com/static-assets'
const cover = backet + '/others/cover.jpeg'

const CertificateVerification = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [stid, setStid] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const students = jsonData.Students

  function handleChange(e) {
    
    setStid(e.target.value)
    setSubmitted(false)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setSearchTerm(stid.trim())
    setSubmitted(true)
  }

  const match = searchTerm
    ? students.find((val) => String(val.SID).toUpperCase() === searchTerm.toUpperCase()) || null
    : null

  return (
    <div className='bg-[#F2F5F8] flex flex-col'>
      <div className='relative w-full h-[300px] mx-h-[300px]'>
        <img src={cover} className='w-full object-cover h-[300px] mx-h-[300px]' alt='cover' />
      </div>
      <div className='flex flex-row sm:flex-col xs:flex-col'>
        <div className='bg-gray-100 shadow-xl md:w-[25%] xl:w-[25%] max:w-[450px] px-10 flex flex-col items-start space-y-5 py-20'>
          <h1 className='capitalize mt-5 text-[#0863AA] text-[20px] font-bold'>
            Certificate Verification
          </h1>
          <p className='text-base text-[#0863AA]'>
            Please enter the student ID written on the transcript.
          </p>

          <form className='w-full flex justify-center flex-col items-center' onSubmit={handleSubmit}>
            <div className='w-full'>
              <input
                className='border-2 border-gray-300 py-3 px-5 text-center text-white w-full focus:outline-none rounded-full bg-[#0863AA]'
                id='stid'
                name='stid'
                value={stid}
                onChange={handleChange}
                placeholder='Enter student ID'
                autoComplete='off'
              />
            </div>
            <button type='submit' className='bg-[#0863AA] text-white my-5 px-3 py-2'>
              Verify
            </button>
          </form>
        </div>

        <div className='md:w-[75%] xl:w-[75%] text-[#0863AA] text-[20px] tracking-wide mt-10'>
          {submitted && searchTerm && !match && (
            <div className='px-5 mt-5'>
              Unfortunately, this student ID does not exist.
            </div>
          )}

          {match && (
            <div className='flex flex-col mt-5 px-5 overflow-hidden'>
              <div className='flex flex-col items-center px-3 space-y-4 sm:text-base xs:text-base'>
                <p>This is to certify that</p>
                <p className='font-bold'>{match.SNAME}</p>
                <p className='md:w-[40%] xl:w-[40%] text-center'>
                  Having passed all the precertified examinations and Satisfied all other university
                  requirements.
                </p>
                <div className='flex flex-row justify-center'>
                  <p>in the year </p>
                  <p className='font-bold mx-2'>{match.Year}</p>
                </div>
                <p>Has been awarded the degree of</p>
                <p className='font-bold mx-2'>{match.Degree}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CertificateVerification
